import * as React from 'react';
import Card from '@mui/material/Card';
import Chip from '@mui/material/Chip';
import CardContent from '@mui/material/CardContent';
import Verctor from '../../Vector.svg';
import Connect from '../../Connect.svg';

export default function UserCard({ user, publicMode, setUserInfo, setUserBox }) {
  // console.log("profile:", user.distance);

  const distanceLable = () => {
    if (user.distance < 10) {
      return "Close";
    } else {
      if (user.distance > 30) {
        return "Far";
      }
    }
    return "Near";
  };

  const redirectToDetail = () => {
    if(!publicMode){
      return
    }else{
      setUserInfo(user)
      setUserBox(true)
    }
    console.log("lalalala", user)
  }

  const cardStyle = !publicMode
    ? {
      minWidth: '48%',
      minHeight: 262,
      borderRadius: '30px',
      display: 'flex',
      flexDirection: 'column',
      backgroundImage: `url(${user.profile})`,
      backgroundSize: 'cover',
      backgroundPosition: 'center',
      position: 'relative', 
      borderRadius: "12px",
      filter: 'blur(4px)', 
      willChange: 'filter',
      transition: 'filter 0.3s ease',
      '&::after': {
        content: '""',
        position: 'absolute',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: 'rgba(255, 255, 255, 0.7)', 
        // filter: 'blur(8px)', 
        borderRadius: '12px', 
        zIndex: 1,
      },
      '@media (max-width: 600px)': {
        minWidth: '48%',  
        minHeight: 270,
      }
    }
    
    : {
        minWidth: '48%',
        minHeight: 262,
        borderRadius: '30px',
        display: 'flex',
        flexDirection: 'column',
        backgroundImage: `url(${user.profile})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        '@media (max-width: 600px)': {  
          minWidth: '48%',  
          minHeight: 270,

        },
        borderRadius: "12px" ,
        borderBottomLeftRadius: "16px",  
        borderBottomRightRadius: "16px"
      };


  const cardContentStyle = !publicMode
    ? {
        color: 'white',
        background: '#000',
        display: 'flex',
        alignItems: 'flex-end',
        fontWeight: 'bold',
        paddingLeft: '12px',
        paddingBottom: '0px',
        fontSize: '18px',
        // filter: 'blur(4px)',
        
      }
    : {
        color: 'white',
        background: '#000',
        display: 'flex',
        alignItems: 'flex-end',
        fontWeight: 'bold',
        paddingLeft: '12px',
        paddingTop: '10px',
        paddingBottom: '0px',
        fontSize: '18px',
      };

  return (
    <Card onClick={redirectToDetail} sx={cardStyle}>
      <div style={{ display: 'flex', justifyContent: 'flex-end', padding: '10px' }}>
        <Chip
          label={distanceLable()}
          avatar={user.connectionTag == 'connected' ? <img src={Connect} alt="Vector Icon" style={{ width: '12px', marginLeft:'0px' }} />: <></>}
          sx={{
            backgroundColor: '#000',
            color: '#FFF',
            width: '60px',
            fontWeight: '800',
            height: '24px',
            justifyContent:'space-around',
            '& .MuiChip-label': {
              paddingLeft: 0, 
              paddingRight: 0, 
              fontSize: '12px',
            }
          }}
        />
      </div>
      <div style={{ flexGrow: 1 }}></div>
      <CardContent sx={cardContentStyle} style={{paddingBottom: "8px", paddingTop: '8px'}}>
        <div style={{ display: "flex", alignItems: "center" }}>
          <div>{user.lastName}</div>
          <img src={Verctor} alt="Vector Icon" style={{ marginLeft: "6px", width: "12px" }} />
        </div>
      </CardContent>
    </Card>
  );
}
